import Button from '@eversports/react-components/primitives/Button'
import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  onClick: () => void
}

const BackButtonComponent: React.FC<React.PropsWithChildren<Props>> = ({ onClick }) => (
  <div>
    <Button variant="secondary" onClick={onClick}>
      <Localized id="back" />
    </Button>
  </div>
)

export default BackButtonComponent
